import { useMutation } from '@tanstack/react-query';
import React, { useCallback, useMemo, useState } from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { Popover, Whisper } from 'rsuite';
import { BaseCell } from '../../../../../../../components';
import { deleteRegra } from '../../../../../../../services/RegrasService';
import { listRulesQueryDeleteMutation } from '../../lib/queries';
import { RuleDataItem } from '../../lib/service';
import DeleteRuleModal from '../DeleteRuleModal/DeleteRuleModal';
import styles from './RulesPageTableActionsCell.module.scss';

type SpeakerOption = { id: string; label: string; onClick?: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>, id: string) => void };

const speaker = (options: SpeakerOption[]) => (
  <Popover>
    <ul className={styles.speaker}>
      {options.map(({ id, label, onClick }) => (
        <li key={id}>
          <button onClick={event => onClick?.(event, id)}>{label}</button>
        </li>
      ))}
    </ul>
  </Popover>
);

const RulesPageTableActionsCell = ({ ruleId, history }: RouteComponentProps & RuleDataItem) => {
  const [isDeleteRuleModalOpen, setIsDeleteRuleModalOpen] = useState(false);

  const handlCloseModal = () => {
    setIsDeleteRuleModalOpen(false);
  };

  const handleClickOpenRule = useCallback(
    (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
      event.preventDefault();
      history.push(`/ipa/regras-preco/${ruleId}`);
    },
    [history, ruleId],
  );

  const handleClickDeleteButton = useCallback((event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    event.preventDefault();
    setIsDeleteRuleModalOpen(true);
  }, []);

  const handleConfirmDelete = useCallback(async () => {
    await deleteRegra(ruleId);
    setIsDeleteRuleModalOpen(false);
  }, [ruleId]);

  const { mutateAsync } = useMutation({
    ...listRulesQueryDeleteMutation(),
    mutationFn: handleConfirmDelete,
  });

  const options = useMemo<SpeakerOption[]>(
    () => [
      { id: 'OPEN', label: 'Abrir e editar', onClick: handleClickOpenRule },
      { id: 'DELETE', label: 'Excluir', onClick: handleClickDeleteButton },
    ],
    [handleClickDeleteButton, handleClickOpenRule],
  );

  return (
    <>
      <BaseCell>
        <button className="ipa-link-button" onClick={handleClickOpenRule}>
          Abrir
        </button>
        <Whisper trigger="click" speaker={speaker(options)} placement="leftEnd">
          <button className="ipa-link-button">Mais...</button>
        </Whisper>
      </BaseCell>
      <DeleteRuleModal isOpen={isDeleteRuleModalOpen} onHide={handlCloseModal} onSubmit={() => mutateAsync()} />
    </>
  );
};

export default withRouter(RulesPageTableActionsCell);
